import { render, staticRenderFns } from "./logisticsxq.vue?vue&type=template&id=29760754&scoped=true&"
import script from "./logisticsxq.vue?vue&type=script&lang=js&"
export * from "./logisticsxq.vue?vue&type=script&lang=js&"
import style0 from "./logisticsxq.vue?vue&type=style&index=0&id=29760754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29760754",
  null
  
)

export default component.exports